import { NavigationGuard } from 'vue-router'
import * as accountTypes from '@account/store/types'
import store from '@/store'
import * as types from '@/store/types';


const authenticated = (): boolean => {
    var current = store.state.$account?.current;
    return current !== null;
};

const processLogin = (): Promise<account.TCurrent> => {
    var userProfile = Office.context.mailbox.userProfile;
    var email = userProfile.emailAddress;

    const eumSSO = (email: string) => {
        (document.querySelector('#global_progress') as any).style.display = 'block';
        return store.dispatch(accountTypes.LOGINHINT, {
            username: email,
            password: ''
        }).then((res) => {
            (document.querySelector('#global_progress') as any).style.display = 'none';
            return res;
        }).catch((err) => {
            (document.querySelector('#global_progress') as any).style.display = 'none';
            return err;
        })
    }

    if (process.env.NODE_ENV === 'production') {
        if (OfficeRuntime && OfficeRuntime.auth && OfficeRuntime.auth.getAccessToken) {      
            (document.querySelector('#global_progress') as any).style.display = 'block';      
            return OfficeRuntime.auth.getAccessToken().then(res => {
                return store.dispatch(accountTypes.LOGINASSERTION, {
                    username: email,
                    userAssertion: res
                }).then((res) => {
                    (document.querySelector('#global_progress') as any).style.display = 'none';
                    return res;
                }).catch((err) => {
                    (document.querySelector('#global_progress') as any).style.display = 'none';
                    return err;
                });
            }).catch((err) => {
                console.error(err);
                return eumSSO(email);
            });
        } else {
            return eumSSO(email);
        }        
    } else {
        return eumSSO(email);
    }
}

const officeAuthGuard: NavigationGuard = async (to, from, next) => {
    let inappAuthenticated = authenticated();

    if (inappAuthenticated) {
        next();
    } else {
        Office.onReady((info) => {
            console.log('info', info)
            if (info.host === Office.HostType.Outlook) {
                processLogin().then(res => {
                    next();
                }).catch(err => {
                    const errorData = encodeURIComponent(JSON.stringify({
                        title: 'error',
                        message: 'Authentication fail'
                    }));
                    next({ name: 'error', query: { data: errorData } });
                });
            } else {
                const errorData = encodeURIComponent(JSON.stringify({
                    title: 'error',
                    message: 'Unsupported host'
                }));
                next({ name: 'error', query: { data: errorData } });
            }
        })

        console.log('not decided');
    }
}

export default officeAuthGuard;